export default {
	"Group.remainder": "剩餘",
	"Group.TheyAreInAGroupAndCanBeDirectlyInvolved": "他們正在拼團，可直接參與",
	"Group.NotBad": "還差",
	"Group.PeopleInGroups": "人成團",
	"Group.GoOnATour": "去參團"
}